//import axios to make request
import axios from "axios";

// get all zones from distributor
export async function getZonesByDistributor({ commit }, payload) {
  try {
    const { data } = await axios.get("/zone/distributor", {
      params: payload,
    });

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}
// get all the zones by distributor
export async function getZonesByDistributorPaged({ commit }, payload) {
  try {
    const { data } = await axios.get("/zone/distributor/paged", {
      params: payload,
    });

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

// create a zone
export async function add({ commit }, payload) {
  try {
    const { data } = await axios.post("/zone/add", payload);

    if (data.error) {
      throw Error(data.message);
    }
    return data;
  } catch (e) {
    Error(e.message);
  }
}

// update a zone
export async function update({ commit }, payload) {
  try {
    const { data } = await axios.put("/zone/update", payload);

    if (data.error) {
      throw Error(data.message);
    }
    return data;
  } catch (e) {
    Error(e.message);
  }
}

// check if there are users in the zone
export async function verifyUsers({ commit }, payload) {
  try {
    const { data } = await axios.get("/zone/verify-delete", {
      params: payload,
    });

    if (data.error) {
      throw Error(data.message);
    }
    return data;
  } catch (e) {
    Error(e.message);
  }
}

// check if there are users in the zone
export async function deleteZone({ commit }, payload) {
  try {
    const { data } = await axios.delete("/zone/delete", {
      params: payload,
    });

    if (data.error) {
      throw Error(data.message);
    }
    return data;
  } catch (e) {
    Error(e.message);
  }
}
